// Generated from fixtures/kitchen-6a9ebcec.xml and models.json by tools/build-pivot-repair.ts.
// Only these exact old placements are eligible; materials and other user edits are excluded.
export const legacyPivotBaseline = [
  {
    "level": 0,
    "id": "im",
    "fingerprint": "[\"im\",\"local\",\"lightings.gold/4983/4983\",\"Models/lightings.gold/4983/4983\",\"wall\",[-3.981,-11.4436],2.0842,-1.5708,[2.6797,0.022,0.016],[1,2.67966,1.00006592],false,\"bottom\",\"wb\",\"wb\",[-4.089,2.3484],[-4.089,-12.8733],[-4.089,-5.2625],[0,-1],[1,0],15.2217,0.2,3,true,3]",
    "elevation": 2.0732,
    "pivot": "center"
  },
  {
    "level": 0,
    "id": "is",
    "fingerprint": "[\"is\",\"local\",\"lightings.gold/4983/4983\",\"Models/lightings.gold/4983/4983\",\"wall\",[-2.6365,-12.7653],2.0811,0,[2.6797,0.022,0.016],[1,2.67966,1.00006592],false,\"bottom\",\"wn\",\"wn\",[-4.089,-12.8733],[1.0756,-12.8733],[-1.5067,-12.8733],[1,0],[0,1],5.1646,0.2,3,true,3]",
    "elevation": 2.0701,
    "pivot": "center"
  },
  {
    "level": 0,
    "id": "iz",
    "fingerprint": "[\"iz\",\"local\",\"Imports/6308/6308\",\"Models/Imports/6308/6308\",\"wall\",[2.5958,-4.6041],2.199,1.5708,[2.9328,0.801,0.4529],[1.21793675,1,0.8986255],false,\"bottom\",\"wx\",\"wx\",[2.9222,-7.561],[2.9222,-3.0234],[2.9222,-5.2922],[0,1],[-1,0],4.5376,0.2,3,true,3]",
    "elevation": 0,
    "pivot": "bottom"
  },
  {
    "level": 0,
    "id": "i10",
    "fingerprint": "[\"i10\",\"local\",\"lightings.gold/4983/4983\",\"Models/lightings.gold/4983/4983\",\"wall\",[2.8142,-3.2764],1.4865,1.5708,[0.022,1.5135,0.016],[1,1.5134896,0.999997258],false,\"bottom\",\"wx\",\"wx\",[2.9222,-7.561],[2.9222,-3.0234],[2.9222,-5.2922],[0,1],[-1,0],4.5376,0.2,3,true,3]",
    "elevation": 1.4117,
    "pivot": "center"
  },
  {
    "level": 0,
    "id": "i11",
    "fingerprint": "[\"i11\",\"local\",\"lightings.gold/4983/4983\",\"Models/lightings.gold/4983/4983\",\"wall\",[2.8142,-3.6728],1.4865,1.5708,[0.022,1.5135,0.016],[1,1.5134896,0.999997258],false,\"bottom\",\"wx\",\"wx\",[2.9222,-7.561],[2.9222,-3.0234],[2.9222,-5.2922],[0,1],[-1,0],4.5376,0.2,3,true,3]",
    "elevation": 0.9705,
    "pivot": "center"
  },
  {
    "level": 0,
    "id": "i12",
    "fingerprint": "[\"i12\",\"local\",\"lightings.gold/4983/4983\",\"Models/lightings.gold/4983/4983\",\"wall\",[2.8142,-3.474],1.4865,1.5708,[0.022,1.5135,0.016],[1,1.5134896,0.999997258],false,\"bottom\",\"wx\",\"wx\",[2.9222,-7.561],[2.9222,-3.0234],[2.9222,-5.2922],[0,1],[-1,0],4.5376,0.2,3,true,3]",
    "elevation": 1.1846,
    "pivot": "center"
  }
] as const;
